<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item>提现管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="姓名">
          <el-input size="small" v-model="formInline.withdrawName" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="small" v-model="formInline.withdrawPhone" clearable placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号码">
          <el-input size="small" v-model="formInline.withdrawCardnum" clearable placeholder="请输入银行卡号码"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="formInline.withdrawStatus"
            placeholder="请选择审核状态"
          >
            <el-option
              v-for="item in activeOptions"
              :key="item.id + '-smlxkey'"
              :label="item.key"
              :value="item.val"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
          size="small"
          v-model="dateRange"
          type="daterange"
          @change="dateChange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="提现开始日期"
          end-placeholder="提现结束日期">
        </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column prop="withdrawName" align="center" label="姓名">
        </el-table-column>
        <el-table-column prop="withdrawPhone" align="center" label="手机号" width="120">
        </el-table-column>
        <el-table-column prop="depositBank" align="center" label="开户行名称" width="120">
        </el-table-column>
        <el-table-column prop="withdrawCardnum" align="center" label="银行卡号码" width="160">
        </el-table-column>
        <el-table-column sortable prop="withdrawMoney" align="center" label="提现金额" width="120">
        </el-table-column>
        <el-table-column prop="delegationHead" align="center" label="人员归属">
          <template slot-scope="scope">
            <div>{{delegationHeadOpts[scope.row.delegationHead*1]}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" align="center" label="申请提现时间" width="140">
          <template slot-scope="scope">
            <div>{{scope.row.createDate|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" align="center" label="审核状态">
          <template slot-scope="scope">
            <el-tag :type="activeType[scope.row.withdrawStatus*1]">{{activeText[scope.row.withdrawStatus*1]}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updateBy" align="center" label="审核人员">
        </el-table-column>
        <el-table-column prop="updateDate" align="center" label="审核时间">
        </el-table-column>
        <el-table-column prop="transferPictureUrl" align="center" label="审核通过图片"  width="120">
          <template slot-scope="scope">
            <div class="imgarea" v-if="scope.row.transferPictureUrl !== null && scope.row.transferPictureUrl.length > 0">
              <el-image
                class="table-img"
                :src="scope.row.transferPictureUrl[0]"
                :preview-src-list="scope.row.transferPictureUrl"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" label="审核驳回理由" width="120">
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleAppro(scope.row,1)" type="success" :disabled="scope.row.withdrawStatus!=0">
             通过
            </el-button>
            <el-button size="mini" @click="handleAppro(scope.row,2)" type="danger" :disabled="scope.row.withdrawStatus!=0">
              驳回
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- 编辑界面 -->
      <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @close="closeDialog">
        <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="提现申请驳回理由" prop="remark" v-if="title == '驳回'">
            <el-input type="textarea"
                      :rows="2" v-model.trim="editForm.remark" auto-complete="off" placeholder="请输入提现申请驳回理由"></el-input>
          </el-form-item>
          <el-form-item label="转账截图" prop="transferPicture" v-if="title == '通过'">
            <el-upload
              :class="{ uoloadSty: showBtnDealImg, disUoloadSty: noneBtnImg }"
              ref="detailImageUpload"
              action="#"
              list-type="picture-card"
              :file-list="fileList"
              :limit="limitCountImg"
              :before-upload="beforeAvatarUpload"
              :on-change="swiperImgChange"
              :http-request="uploadArrBinary"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
              </div>
              <div slot="tip" class="img_size_tip">
                请上传转账记录图片
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt=""/>
            </el-dialog>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </template>

  <script>
  import { withdrawalReviewList,withdrawalProcess } from '@/api/system'
  import {upimg} from "@/api/userMG";
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        noneBtnImg: false, //图片按钮显示隐藏
        showBtnDealImg: true,
        fileList: [],
        limitCountImg: 4,
        disabled: false,
        dialogVisible: false,
        dialogImageUrl: "",
        detailImageArr: [],

        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        delegationHeadOpts:['国药','普通'],
        activeText:['待审核','通过','驳回'],
        activeType:['info','success','danger'],
        activeOptions: [
          {
            id:1,
            key:'待审核',
            val:'0'
          },
          {
            id:2,
            key:'通过',
            val:'1'
          },
          {
            id:3,
            key:'驳回',
            val:'2'
          }
        ],
        editForm: {
          id:null,
          withdrawStatus:null,
          remark:null,
          transferPicture:null,
        },
        // rules表单验证
        rules: {
          remark: [
            { required: true, message: '请输入提现申请驳回理由', trigger: 'blur' }
          ],
          transferPicture: [
            {required: true, message: "请上传转账记录图片", trigger: "change"},
          ],
        },
        formInline: {
          page: 1,
          limit: 10,
          withdrawName:null,
          withdrawPhone:null,
          withdrawCardnum:null,
          withdrawStatus:null,
          beginTime:null,
          endTime:null
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        dateRange:null,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
         withdrawalReviewList(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 200) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page=1
        this.getdata(this.formInline)
      },
      //显示编辑界面
      // handleEdit: function(index, row) {
      //   this.editFormVisible = true
      //   if (row != undefined && row != 'undefined') {
      //     this.title = '修改'
      //     this.editForm.status = row.status
      //     this.editForm.cnName = row.cnName
      //     this.editForm.id = row.id
      //   } else {
      //     this.title = '添加'
      //     this.editForm.status = '1'
      //     this.editForm.cnName = ''
      //   }
      // },
      handleAppro(row,i){
        this.editFormVisible = true
        this.title = i =='1'?'通过':'驳回'
        this.editForm.id = row.id;
        this.editForm.withdrawStatus = i
        // let text = i=='1'?'通过':'驳回'
        // this.$confirm('确定要'+text+'吗?', '信息', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'warning'
        //     }).then(()=>{
        //       let par = {
        //         id:row.id,
        //         status:i
        //       }
        //       withdrawalProcess(par).then(res=>{
        //         if(res.rsp_code==200){
        //           this.$message.success(text+'成功！')
        //           this.getdata(this.formInline)
        //         }else{
        //           this.$message.error(text+'失败！')
        //         }
        //       })
        //     })
      },
      // 编辑页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            this.loading = true
            withdrawalProcess(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.rsp_code==200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: `${this.title}成功！`
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error(`${this.title}失败，请稍后再试！`)
              })
          } else {
            return false
          }
        })
      },
      // 删除公司
      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delDictType({id:row.id})
              .then(res => {
                if (res.rsp_code==200) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false;
        this.$refs['editForm'].resetFields()
        this.editForm = {
          id:null,
          withdrawStatus:null,
          remark:null,
          transferPicture:null,
        }
      },
      dateChange(v){
        if(!!v){
          this.formInline.beginTime	= v[0]
        this.formInline.endTime	= v[1]
        }else{
          this.formInline.beginTime	= null
        this.formInline.endTime	= null
        }

      },
      //图片上传方法
      uploadArrBinary(filePath) {
        let formData = new FormData();
        formData.append("file", filePath.file);
        upimg(formData).then((res) => {
          this.detailImageArr.push(res.body.imageNo);
          this.editForm.transferPicture = this.detailImageArr.join(",");
          console.log(this.editForm.transferPicture)
          this.$refs['editForm'].validateField('transferPicture')
        });
      },
      swiperImgChange(file, fileList) {
        this.fileList = fileList;
        this.noneBtnImg = fileList.length >= this.limitCountImg;
      },
      beforeAvatarUpload(file) {
        // console.log(file,'图片文件before');
        const isJPG =
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error("只能上传jpg或png格式!");
        }
        if (!isLt2M) {
          this.$message.error("图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
        // return isLt2M;
      },
      handleRemove(file) {
        const index = this.fileList.findIndex((e) => e.uid === file.uid);
        this.fileList.splice(index, 1);
        this.noneBtnImg = this.fileList.length >= this.limitCountImg; //添加按钮显隐
        // 删除的时候把this.editForm.detailImage 对应的imgNo删掉
        this.detailImageArr.splice(index, 1);
        this.editForm.detailImage = this.detailImageArr.join(";");
      },
      // 多图预览
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    }
  }
  </script>

  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>




// WEBPACK FOOTER //
// src/views/withdrawManage/withdrawLog.vue